import React from 'react'

interface LogoProps {
  size?: number
}

const Logo: React.FC<LogoProps> = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* 外圆 - 渐变底 */}
    <defs>
      <linearGradient id="logo-bg" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#1890ff" />
        <stop offset="100%" stopColor="#096dd9" />
      </linearGradient>
      <linearGradient id="logo-accent" x1="16" y1="20" x2="48" y2="52" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95" />
        <stop offset="100%" stopColor="#e6f7ff" stopOpacity="0.9" />
      </linearGradient>
    </defs>

    <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#logo-bg)" />

    {/* 聊天气泡 - 左 */}
    <rect x="12" y="16" width="26" height="18" rx="9" fill="url(#logo-accent)" />
    <polygon points="18,34 14,40 22,34" fill="url(#logo-accent)" />

    {/* 气泡内三点 */}
    <circle cx="19" cy="25" r="2" fill="#1890ff" />
    <circle cx="25" cy="25" r="2" fill="#1890ff" />
    <circle cx="31" cy="25" r="2" fill="#1890ff" />

    {/* 聊天气泡 - 右 (AI) */}
    <rect x="26" y="32" width="26" height="16" rx="8" fill="#ffffff" fillOpacity="0.55" />
    <polygon points="46,48 50,54 42,48" fill="#ffffff" fillOpacity="0.55" />

    {/* AI 闪电符号 */}
    <path
      d="M38 36 L35 42 L39 42 L36 48"
      stroke="#ffffff"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
)

export default Logo
